var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconViewsMapView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_views_map_view",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "location_on_FILL1_wght400_GRAD0_opsz48",
    d: "M18,16.188a2.188,2.188,0,0,0,1.547-3.734,2.188,2.188,0,0,0-3.094,3.094A2.108,2.108,0,0,0,18,16.188ZM18,29a41.554,41.554,0,0,1-7.516-7.953A12.368,12.368,0,0,1,8,14.25a9.667,9.667,0,0,1,3.016-7.469,10.16,10.16,0,0,1,13.969,0A9.667,9.667,0,0,1,28,14.25a12.368,12.368,0,0,1-2.484,6.8A41.554,41.554,0,0,1,18,29Z",
    transform: "translate(-8 -4)",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconViewsMapView);
export default __webpack_public_path__ + "static/media/icon_views_map_view.ab128c6612456a0c45eef770f14269c5.svg";
export { ForwardRef as ReactComponent };